/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */
import { FunctionComponent, useState, useCallback, useEffect } from 'react';
import styles from '../../styles/pages/WelcomeScreenSignup1.module.css';
import IOCMImage from '../../../src/assets/images/ICM Logo.png';
import InputField from '../../components/controlVariations/InputField';
import { Cta } from '../../components/controlVariations/Cta';
import { useAuth } from '../../hooks/useAuth';
// import { useNavigate } from 'react-router-dom';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AuthInfoCard from '../controlVariations/AuthInfoCard';
import successIcon from '../../assets/images/success.png';
import Checkbox from '../controlVariations/checkbox';
import {
	syncPasswordMatchError,
	validateEmail,
	validateFullNameUI,
	validatePassword,
	validatePasswordMatch,
} from '../../utils/validation';
import { sanitizeEmailInput } from '../../utils/sanitize';
import { useInvitation } from '../../hooks/useInvitation';

const WelcomeScreenSignup1: FunctionComponent = () => {
	const [signupSuccess, setSignupSuccess] = useState(false);
	// Error state
	const [errors, setErrors] = useState<{ [key: string]: string }>({});

	const navigate = useNavigate();

	// Form state
	const [form, setForm] = useState({
		// 🔴 Mandatory
		fullName: '',
		email: '',
		password: '',
		rePassword: '',

		// 🟡 Optional
		username: '',
		organization: '',
		designation: '',

		skills: [] as string[],
		areasOfInterest: [] as string[],
		growthparameters: [] as string[],
		languages: [] as string[],

		phonenumber: '',
		country: '',
		location: '',
		timezone: '',

		yearsofexperience: '',
		coachingexperience: [] as string[],
	});

	const [searchParams] = useSearchParams();

const invitationToken = searchParams.get('token');



const {
    verifyInvitation,
    acceptInvitation,
} = useInvitation();

const [isInvitationSignup, setIsInvitationSignup] = useState(false);
const [invitationLoading, setInvitationLoading] = useState(false);

useEffect(() => {
    const verifyInvite = async () => {
        if (!invitationToken) {
            // Normal signup - do nothing
            return;
        }

        setInvitationLoading(true);

        try {
            const response = await verifyInvitation(invitationToken);

            if (!response.success) {
                setErrors({
                    email:
                        response.message ||
                        'Invalid or expired invitation',
                });
                return;
            }

            // This is an invitation signup
            setIsInvitationSignup(true);

            const invitation = response.data;

            // Prefill values from invitation
            setForm(prev => ({
                ...prev,
                fullName: invitation.fullname || '',
                email: invitation.email || '',
                organization: invitation.organizationname || '',
                phonenumber: invitation.phonenumber || '',
            }));
        } catch (error) {
            console.error(
                'Invitation verification failed:',
                error
            );

            setErrors({
                email: 'Invalid or expired invitation',
            });
        } finally {
            setInvitationLoading(false);
        }
    };

    verifyInvite();
}, [invitationToken, verifyInvitation]);

	const onAlreadyRegisteredSignClick = useCallback(() => {
		navigate('/');
	}, [navigate]);

	// Common input change handler
	const handleInputChange = (field: keyof typeof form, value: string) => {
		setForm(prev => ({ ...prev, [field]: value }));
		if (errors[field]) {
			setErrors(prev => ({ ...prev, [field]: '' }));
		}
	};

	const { register } = useAuth();

	const validateStep1 = (): boolean => {
		const newErrors: { [key: string]: string } = {};

		// if (!form.fullName) newErrors.fullName = 'Full name is required';
		const fullNameError = validateFullNameUI(form.fullName);
		if (fullNameError) {
			newErrors.fullName = fullNameError;
		}

		if (!form.email) {
			newErrors.email = 'Email is required';
		} else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
			newErrors.email = 'Enter a valid email address';
		}

		const passwordError = validatePassword(form.password);
		if (passwordError) {
			newErrors.password = passwordError;
		}

		if (form.rePassword !== form.password) {
			newErrors.rePassword = 'Passwords do not match';
		}

		if (Object.keys(newErrors).length > 0) {
			setErrors(newErrors);
			return false; // ❌ validation failed
		}

		return true; // ✅ validation passed
	};

	const mapBackendErrorToField = (message: string) => {
		const lower = message.toLowerCase();

		if (
			lower.includes('password') ||
			lower.includes('uppercase') ||
			lower.includes('lowercase') ||
			lower.includes('number') ||
			lower.includes('special') ||
			lower.includes('pattern')
		) {
			return 'password';
		}

		if (lower.includes('email')) {
			return 'email';
		}

		return 'email'; // fallback
	};
	const formatBackendError = (message: string) => {
		const lower = message.toLowerCase();

		if (lower.includes('password') && lower.includes('fails to match')) {
			return 'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character.';
		}

		if (lower.includes('email') && lower.includes('exists')) {
			return 'This email is already registered. Please sign in.';
		}

		return message;
	};

	const handleSignup = async () => {
		if (iagree !== true || trems !== true) return;
		// STEP 1 validation before DB call
		const isValid = validateStep1();
		if (!isValid) return; // ⛔ stop signup

		try {
			const payload: any = {
				isLoginRequired: true,
				email: form.email,
				password: form.password,
				fullname: form.fullName,
			};

			// ✅ Add optional fields ONLY if filled
			if (form.organization.trim()) {
				payload.organizationname = form.organization;
			}
			if (form.coachingexperience?.length > 0) {
				payload.coachingexperience = form.coachingexperience;
			}

			if (form.growthparameters?.length > 0) {
				payload.growthparameters = form.growthparameters;
			}

			if (form.designation.length > 0)
				payload.designation = form.designation;

			if (form.skills.length > 0) payload.skills = form.skills;

			if (form.areasOfInterest.length > 0) {
				payload.areasofinterest = form.areasOfInterest; // ✅ DIRECT ARRAY
			}

			if (form.languages.length > 0) payload.languages = form.languages;

			if (form.phonenumber.trim()) payload.phonenumber = form.phonenumber;

			if (form.country.trim()) payload.country = form.country;

			if (form.location.trim()) payload.location = form.location;

			if (form.timezone.trim()) payload.timezone = form.timezone;

			if (form.yearsofexperience.trim())
				payload.yearsofexperience = form.yearsofexperience;

			// await register(payload);

			// setSignupSuccess(true);
			if (isInvitationSignup && invitationToken) {
    // Invitation signup
    const response = await acceptInvitation(
        invitationToken,
        {
            fullname: form.fullName,
            password: form.password,
        }
    );

    if (!response.success) {
        throw new Error(
            response.message ||
            'Failed to accept invitation'
        );
    }

    setSignupSuccess(true);
} else {
    // Existing normal signup flow
    await register(payload);
    setSignupSuccess(true);
}
		} catch (err: any) {
			const rawMessage =
				err?.response?.data?.message ||
				err?.message ||
				'Something went wrong';

			const friendlyMessage = formatBackendError(rawMessage);
			const field = mapBackendErrorToField(rawMessage);

			setErrors(prev => ({
				...prev,
				[field]: friendlyMessage,
			}));
		}
	};

	const [iagree, setIagree] = useState<boolean | 'indeterminate'>(false);
	const [trems, setTerms] = useState<boolean | 'indeterminate'>(false);
	const isButtonEnabled = iagree === true && trems === true;

	return (
		<div className={styles.welcomeScreensignup1}>
			{signupSuccess && (
				<div className={styles.overlay}>
					<AuthInfoCard
						title="Signup Successful"
						description1="Welcome aboard! Your account has been created. "
						description2="Answer a few questions to help us understand you better."
						iconSrc={successIcon}
						showButton={true}
						buttonText="Let’s get started"
						onButtonClick={() => {
							console.log('CTA clicked');
							navigate('/dashboard');
						}}
					/>
				</div>
			)}
			<div className={styles.welcomeScreensignup1Child}>
				<div className={styles.logowrapper}>
					<img className={styles.icmLogo1} alt="" src={IOCMImage} />
				</div>

				<>
					<div className={styles.signupParent}>
						<>
							<div className={styles.head}>
								<div className={styles.signup}>Signup</div>
								<div className={styles.iconCont}>
									<div className={styles.mandatoryCont}>
										<span className={styles.redAsterisk}>
											*
										</span>
										<div className={styles.mandatory}>
											Mandatory Fields
										</div>
									</div>
								</div>
							</div>
							<div className={styles.inputFields1}>
								<div className={styles.label}>
									Full name
									<span className={styles.redAsterisk}>
										*
									</span>
								</div>

								<InputField
									type="text"
									placeholder="John Doe"
									value={form.fullName}
									disabled={isInvitationSignup}
									onChange={(e: any) => {
										const value = e.target.value;

										handleInputChange('fullName', value);

										const error = validateFullNameUI(value);
										setErrors(prev => ({
											...prev,
											fullName: error,
										}));
									}}
								/>

								{errors.fullName && (
									<p className={styles.errorText}>
										{errors.fullName}
									</p>
								)}
							</div>

							<div className={styles.inputFields1}>
								<div className={styles.label}>
									Email Id
									<span className={styles.redAsterisk}>
										*
									</span>
								</div>

								<InputField
									type="email"
									placeholder="john.doe@gmail.com"
									 disabled={isInvitationSignup}
									value={form.email}
									onChange={(e: any) => {
										const rawValue = e.target.value;
										const sanitizedValue =
											sanitizeEmailInput(rawValue);

										handleInputChange(
											'email',
											sanitizedValue
										);

										const error =
											validateEmail(sanitizedValue);
										setErrors(prev => ({
											...prev,
											email: error,
										}));
									}}
									onKeyDown={(e: any) => {
										if (e.key === ' ') {
											e.preventDefault(); // 🚫 block space key completely
										}
									}}
								/>

								{errors.email && (
									<p className={styles.errorText}>
										{errors.email}
									</p>
								)}
							</div>

							<div className={styles.inputFields1}>
								<div className={styles.label}>
									Enter Password
									<span className={styles.redAsterisk}>
										*
									</span>
								</div>

								<InputField
									type="password"
									placeholder="********"
									value={form.password}
									onChange={(e: any) => {
										const value = e.target.value;

										handleInputChange('password', value);

										// password strength validation (existing)
										const passwordError =
											validatePassword(value);
										setErrors(prev => ({
											...prev,
											password: passwordError,
										}));

										// 🔁 SYNC re-password when password changes
										const matchError =
											syncPasswordMatchError(
												value,
												form.rePassword
											);
										setErrors(prev => ({
											...prev,
											rePassword: matchError,
										}));
									}}
								/>

								{errors.password && (
									<p className={styles.errorText}>
										{errors.password}
									</p>
								)}
							</div>

							<div className={styles.inputFields1}>
								<div className={styles.label}>
									Re-enter Password
									<span className={styles.redAsterisk}>
										*
									</span>
								</div>

								<InputField
									type="password"
									placeholder="********"
									value={form.rePassword}
									onChange={(e: any) => {
										const value = e.target.value;

										handleInputChange('rePassword', value);

										const matchError =
											validatePasswordMatch(
												form.password,
												value
											);
										setErrors(prev => ({
											...prev,
											rePassword: matchError,
										}));
									}}
								/>

								{errors.rePassword && (
									<p className={styles.errorText}>
										{errors.rePassword}
									</p>
								)}
							</div>
							<div className={styles.action}>
								<Checkbox
									id="iagree"
									label=""
									checked={iagree}
									onChange={setIagree}
									checkedColor="#00b050"
									borderColor="#ccc"
									labelColor="#333"
									labelFontSize={14}
									triState={false}
								/>
								<span className={styles.iAgreeTo}>
									I agree to the collection and processing of
									my personal data for authentication, access,
									and usage of the IOCM E2I platform, as
									described in the Privacy Policy.
								</span>
							</div>
							<div className={styles.action}>
								<Checkbox
									id="trems"
									label=""
									checked={trems}
									onChange={setTerms}
									checkedColor="#00b050"
									borderColor="#ccc"
									labelColor="#333"
									labelFontSize={14}
									triState={false}
								/>
								<span className={styles.iAgreeTo}>
									I have read and agree to the{' '}
									<span
										className={styles.signIn}
										style={{ cursor: 'pointer' }}
									>
										IOCM Privacy Policy{' '}
									</span>
									and accept the{' '}
									<span
										className={styles.signIn}
										style={{ cursor: 'pointer' }}
									>
										Terms & Conditions.
									</span>
								</span>
							</div>

							<Cta
								variant="primary"
								state={isButtonEnabled ? 'default' : 'inactive'}
								onClick={handleSignup}
							>
								Signup
							</Cta>

							<div
								className={
									styles.alreadyRegisteredSignContainer
								}
							>
								<span>Already registered? </span>
								<span
									className={styles.signIn}
									onClick={onAlreadyRegisteredSignClick}
									style={{ cursor: 'pointer' }}
								>
									Login Now
								</span>
							</div>
						</>
					</div>
				</>
			</div>
		</div>
	);
};

export default WelcomeScreenSignup1;
